var classofRaw = require('../internals/classof-raw');
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/function-uncurry-this-clause.js
// module id = 500
// module chunks = 0